<template>
    <table 
        class="table table-hover table-sm"
    >
        <thead>
            <tr>
                <th scope="col"
                    class="text-left" style="width: 55%;">Parada</th>
                <!-- <th>order</th> -->
                <th scope="col"
                    class="text-left">PAX</th>
                <th scope="col"
                    class="text-left">1/2</th>
                <th scope="col"
                    class="text-left">Total</th>
                <th scope="col"
                    class="text-left">Hora</th>
                <th scope="col"
                    class="text-left">
                    <i class="fa fa-wrench"></i>    
                </th>
            </tr>
        </thead>
        <draggable tag="tbody" v-model="bus.path" @end="onEndDrag" v-if="bus.path.length > 0">
            <bus-path-table-row 
                v-for="(stop,idx) in bus.path"
                :key="idx"
                :row="stop" 
            />
        </draggable>
        <tr v-if="bus.path.length > 0" class="mt-3" style="border-top: 1px solid #afafaf;">
            <td class="text-right pr-5 pt-2">Totales</td>
            <td class="pt-2">{{countAdults}}</td>
            <td class="pt-2">{{countChildren}}</td>
            <td class="pt-2">{{countTotal}}</td>
            <td></td>
            <!-- <td></td> -->
            <td></td>
        </tr>
        <tbody v-if="bus.path.length == 0">
            <tr>
                <td colspan="7" class="text-center pt-5">
                    Sin paradas asignadas
                </td>
            </tr>
        </tbody>
    </table>

</template>

<script>
/* eslint-disable */
import BusPathTableRow from '../BusPath/BusPathTableRow'
import draggable from "vuedraggable"
import {move} from 'move-position'

export default {
    components:  {
        BusPathTableRow,
        draggable
    },
    props: {
        bus: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            countAdults: 0,
            countChildren: 0,
            countTotal: 0,
        }
    },
    created() {
        this.countAdults = this.countAdultsF()
        this.countChildren = this.countChildrenF()
        this.countTotal = this.countAdults + this.countChildren
    },
    methods: {
        onEndDrag(evt) {
            this.$store.dispatch('buses/reorderBusPath', {
                bus_id: this.bus.bus_id,
                oldIdx: evt.oldIndex,
                newIdx: evt.newIndex,
            }).then(() => {
                this.$notify({
                    group: "foo",
                    title: "Parada reordenada",
                    text: "Se ha reordenado la parada seleccionada",
                    type: "success",
                });
            })
        },
        countAdultsF() {
            let adults = 0
            for ( let idx in this.bus.path) {
                adults = adults + this.bus.path[idx].count_adults
            }
            return adults
        },
        countChildrenF() {
            let children = 0
            for ( let idx in this.bus.path) {
                children = children + this.bus.path[idx].count_children
            }
            return children
        },
    }
}
</script>